import Loader from 'react-loaders';
import './index.scss';
import AnimatedLetters from '../AnimatedLetters';
import { useEffect, useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';

const Contact = () => {
    const [letterClass, setLetterClass] = useState('text-animate');
    const refForm = useRef();
    const position = [30.9010, 75.8573];
    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    })
    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_1vv9yxl', 'template_xoxcizq', refForm.current, 'JFj7DBD4DAIREzqJK')
            .then(() => {
                alert('Message successfully sent!');
                // window.location.reload(false);
                // console.log(result.text);
            }, () => {
                // console.log(error.text);
                alert('Failed to send the message!')
            });

    }
    return (
        <>
            <div className="container contact-page">
                <div className='text-zone'>
                    <h1>
                        <AnimatedLetters letterClass={letterClass} strArray={'Contact me'.split('')} idx={15} />
                    </h1>
                    <p>
                        I am currently looking for a new opportunity, my inbox is always open. Whether you have a question or just want to say hi, I will try my best to get back to you!
                    </p>
                    <div className="contact-form">
                        <form ref={refForm} onSubmit={sendEmail}>
                            <ul>
                                <li className="half">
                                    <input type="text" name="name" placeholder="Name" required />
                                </li>
                                <li className="half">
                                    <input type="email" name="email" placeholder="Email" required />
                                </li>
                                <li>
                                    <input placeholder='Subject' type="text" name="subject" required />
                                </li>
                                <li>
                                    <textarea placeholder='message' name="message" required></textarea>
                                </li>
                                <li>
                                    <input type="submit" className='flat-button' value="Send" />
                                </li>
                            </ul>
                        </form>
                    </div>
                </div>
                <div className="info-map">
                    Ayush Kumar
                    <br />
                    Punjab,
                    <br />
                    India
                    <br />
                    <span>kumarayush15aug01@gmail.com</span>
                </div>
                <div className='map-wrap'>
                    <MapContainer center={position} zoom={13} scrollWheelZoom={true}>
                        <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker position={position}>
                            <Popup>
                                A pretty CSS3 popup. <br /> Easily customizable.
                            </Popup>
                        </Marker>
                    </MapContainer>
                </div>
            </div>
            <Loader type='pacman' />
        </>
    )
}
export default Contact;